module.exports = __webpack_public_path__ + "static/media/jelle.622c61a7.png";